import { useState } from "react";
import PropTypes from "prop-types";
import PaymentServices from "../../services/PaymentServices";
import "./payment.css";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

const PaymentPage = ({ amount, reemcode, onSuccess, pageType }) => {
  const [form, setForm] = useState({
    cardNumber: "",
    expiry: "",
    firstName: "",
    lastName: "",
    zipCode: "",
    country: "United States",
    phone: "",
    payPalId: "", // Fixed: Correct field name
  });
  const navigate = useNavigate();
  const [paymentMethod, setPaymentMethod] = useState("card");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [isReemCodeChecked, setIsReemCodeChecked] = useState(false);
  const [reemCodeInput, setReemCodeInput] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    let sanitizedValue = value;

    if (name === "cardNumber") {
      sanitizedValue = value.replace(/\D/g, "").slice(0, 16);
    } else if (name === "expiry") {
      sanitizedValue = value.replace(/\D/g, "").slice(0, 4);
      if (sanitizedValue.length >= 2) {
        sanitizedValue =
          sanitizedValue.slice(0, 2) +
          (sanitizedValue.length > 2 ? "-" + sanitizedValue.slice(2) : "");
      }
    } else if (name === "cardCode") {
      sanitizedValue = value.replace(/\D/g, "").slice(0, 4);
    }

    setForm({ ...form, [name]: sanitizedValue });

    if (
      (name === "cardNumber" && /^[0-9]{16}$/.test(sanitizedValue)) ||
      (name === "expiry" && /^([0-9]{2})\-([0-9]{2})$/.test(sanitizedValue)) ||
      (name === "cardCode" && /^[0-9]{3,4}$/.test(sanitizedValue))
    ) {
      setMessage("");
    }
  };
  const validateCardDetails = () => {
    const { cardNumber, expiry, cardCode } = form;

    const isValidCardNumber = (number) => {
      let sum = 0;
      let shouldDouble = false;
      for (let i = number.length - 1; i >= 0; i--) {
        let digit = parseInt(number[i], 10);
        if (shouldDouble) {
          digit *= 2;
          if (digit > 9) digit -= 9;
        }
        sum += digit;
        shouldDouble = !shouldDouble;
      }
      return sum % 10 === 0;
    };

    if (!/^[0-9]{13,19}$/.test(cardNumber) || !isValidCardNumber(cardNumber)) {
      setMessage("Invalid card number");
      return false;
    }

    if (!/^([0-9]{2})-([0-9]{2})$/.test(expiry)) {
      setMessage("Invalid expiry date format (MM-YY)");
      return false;
    }

    const [expMonth, expYearShort] = expiry.split("-").map(Number);
    const currentYearFull = new Date().getFullYear();
    const currentCentury = Math.floor(currentYearFull / 100) * 100;
    const expYear =
      expYearShort +
      (expYearShort < currentYearFull % 100
        ? currentCentury + 100
        : currentCentury);
    const currentYear = new Date().getFullYear();
    const currentMonth = new Date().getMonth() + 1;

    if (
      expYear < currentYear ||
      (expYear === currentYear && expMonth < currentMonth)
    ) {
      setMessage("Card is expired");
      return false;
    }

    if (!/^[0-9]{3,4}$/.test(cardCode)) {
      setMessage("Invalid CVV (3-4 digits)");
      return false;
    }

    setMessage("");
    return true;
  };

  function formatMonthYear(input) {
    let [month, year] = input.split("-");
    return `20${year}-${month}`; // Assuming years are in the 2000s
  }

  const handleSubmit = async () => {
    setLoading(true);
    setMessage("");
    if (paymentMethod === "card" && !validateCardDetails()) {
      setLoading(false);
      return;
    }
    try {
      let formattedValue = formatMonthYear(form.expiry);
      const paymentDetails =
        paymentMethod === "card"
          ? {
              cardNumber: form.cardNumber,
              expirationDate: formattedValue,
              cardCode: form.cardCode || "123",
            }
          : {
              payPalId: form.payPalId,
            };

      const requestBody = {
        firstName: form.firstName,
        lastName: form.lastName,
        zipCode: form.zipCode,
        country: form.country,
        phone: form.phone,
        amount,
        isFromUrl: !!reemcode,
        reemcode: !!reemcode ? reemcode : reemCodeInput,
        paymentMethod,
        paymentDetails,
        type: pageType,
      };

      console.log("Payment requestBody:", requestBody);

      const response = await PaymentServices.payNow(requestBody);
      console.log("Payment response:", response);

      if (response.success) {
        Swal.fire({
          title: "Success!",
          text: "Payment Sucessfull !",
          icon: "success",
          confirmButtonText: "OK",
        });
        setMessage(response.message || "Payment Successful!");
        // document.querySelector('.validation-message').style.color = 'green';

        // ✅ Ensure role is correctly parsed from localStorage
        const userrole = Number(localStorage.getItem("userrole")); // Convert string to number
        console.log("Parsed User Role:", userrole);

        // ✅ Add console log before navigating
        console.log("Navigating to:", userrole);

        // ✅ Call `navigate` immediately
        switch (userrole) {
          case 1:
            console.log("Redirecting to /school-dashboard");
            navigate("/school-dashboard");
            break;
          case 2:
            console.log("Redirecting to /schoolteacher-dashboard");
            navigate("/test/mcq-test");
            break;
          case 3:
            console.log("Redirecting to /teacher-dashboard");
            navigate("/test/mcq-test");
            break;
          case "admin":
            console.log("Redirecting to /admin/admin-dashboard");
            navigate("/admin/admin-dashboard");
            break;
          default:
            console.log("Redirecting to /dashboard");
            navigate("/dashboard");
            break;
        }
      } else {
        setMessage(response.message || "Payment failed. Please try again.");
      }
    } catch (error) {
      console.error("Payment Error:", error.response?.data || error.message);
      setMessage(
        error.response?.data?.error || "Payment failed. Please try again."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="home-slide d-flex align-items-center">
      <div className="payment-page">
        <h2>Complete Your Payment</h2>
        <div className="discount">
          <p>Total Amount: ${amount}</p>
          {(amount === 800 || amount === 240) && (
            <img className="discount__img" src={require("../../assets/img/discount.jpg")}></img>
          )}
        </div>

        {/* Payment Method Selection */}
        <div className="payment-method">
          <button
            className={paymentMethod === "card" ? "active" : "nonactive"}
            onClick={() => setPaymentMethod("card")}
          >
            Credit/Debit
          </button>
          <button
            className={paymentMethod === "paypal" ? "active" : "nonactive"}
            onClick={() => setPaymentMethod("paypal")}
          >
            PayPal
          </button>
        </div>

        {paymentMethod === "card" ? (
          <div className="card-details">
            <input
              type="text"
              name="cardNumber"
              placeholder="Card Number"
              value={form.cardNumber}
              onChange={handleChange}
              required
            />
            <input
              type="text"
              name="expiry"
              placeholder="MM-YY"
              value={form.expiry}
              onChange={handleChange}
              required
            />
            <input
              type="text"
              name="cardCode"
              placeholder="CVV"
              value={form.cardCode}
              onChange={handleChange}
              required
            />
            <div className="name-fields">
              <input
                type="text"
                name="firstName"
                placeholder="First Name"
                value={form.firstName}
                onChange={handleChange}
                required
              />
              <input
                type="text"
                name="lastName"
                placeholder="Last Name"
                value={form.lastName}
                onChange={handleChange}
                required
              />
            </div>
            <input
              type="text"
              name="zipCode"
              placeholder="Zip Code"
              value={form.zipCode}
              onChange={handleChange}
              required
            />
            <select
              name="country"
              value={form.country}
              onChange={handleChange}
              required
            >
              <option value="United States">United States</option>
              <option value="United Kingdom">United Kingdom</option>
              <option value="Canada">Canada</option>
            </select>
            <input
              type="text"
              name="phone"
              placeholder="Phone Number (Optional)"
              value={form.phone}
              onChange={handleChange}
            />
            {!reemcode && (
              <div className="content-flex">
                <input
                  type="checkbox"
                  onClick={() => setIsReemCodeChecked((prev) => !prev)}
                  className="content-checkbox"
                />
                <p className="content-text">Use Promo Code</p>
                {isReemCodeChecked && (
                  <input
                    type="text"
                    className="content-input-text"
                    onChange={(e) => setReemCodeInput(e.target.value)}
                    value={reemCodeInput}
                  />
                )}
              </div>
            )}
          </div>
        ) : (
          <div className="paypal-details">
            <input
              type="email"
              name="payPalId" // Fixed: Correct field name
              placeholder="PayPal Email"
              value={form.payPalId}
              onChange={handleChange}
              required
            />
          </div>
        )}

        <button onClick={handleSubmit} disabled={loading}>
          {loading ? "Processing..." : "Pay Now"}
        </button>
        {message && (
          <p className="validation-message" style={{ color: "red" }}>
            {message}
          </p>
        )}
      </div>
    </section>
  );
};

// ✅ Fixed PropTypes Definition
PaymentPage.propTypes = {
  amount: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  reemcode: PropTypes.oneOfType([PropTypes.string]),
  onSuccess: PropTypes.func.isRequired, // Fixed: Should be a function
  pageType: PropTypes.oneOfType([PropTypes.string]).isRequired,
};

export default PaymentPage;
